import { FC } from "react";
import { trackHeader as track } from "~/events";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { Users01 } from "~/icons";
import { MessageNavItem } from "./MessageNavItem";

export const MessageCrewNavItem: FC = () => {
  const user = useCurrentUser();

  if (!user) return null;

  const link = user.cohort.cohortWhatsAppLink;

  return (
    <MessageNavItem
      left={<Users01 mr={2} />}
      link={link}
      onClick={track.messageCrew}
      who="crew"
    />
  );
};
